import React from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import classnames from 'classnames';

const getItemSource = (source) => {
  if (typeof source === 'string') {
    return source;
  }
  const isMobile = bowser.mobile;
  if (isMobile) {
    return source.mobile;
  }
  return source.desktop;
};

const defaultCaptions = {};

function TourItem({
  src = '',
  type,
  footer = true,
  component = null,
  captions = defaultCaptions,
  bgScreen = '',
  className = '',
}) {
  const { title, subtitle } = captions;

  const renderBody = () => {
    switch (type) {
      case 'custom':
        return component;
      case 'video':
        return (
          <video
            loop
            muted
            autoPlay
            controls={false}
            preload="auto"
            src={getItemSource(src)}
            playsInline
          />
        );
      case 'image':
      default:
        return <img alt={title} src={getItemSource(src)} />;
    }
  };

  return (
    <div className={classnames('ws-tour__item', `ws-tour__item--${type}`, className)}>
      <div
        className="ws-tour__item-body"
        style={{
          background: bgScreen,
        }}
      >
        {renderBody()}
      </div>
      {footer && (
        <div className="ws-tour__item-footer">
          <div className="ws-tour__item-footer-title">{title}</div>
          <div className="ws-tour__item-footer-subtitle">{subtitle}</div>
        </div>
      )}
    </div>
  );
}

TourItem.propTypes = {
  type: PropTypes.string.isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  src: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      mobile: PropTypes.string,
      web: PropTypes.string,
    }),
  ]),
  bgScreen: PropTypes.string,
  footer: PropTypes.string,
  component: PropTypes.element,
  className: PropTypes.string,
};

export default TourItem;
